import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Images } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";
import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { api, fileUrl } from "../lib/api";
import { GALLERY_CATEGORIES } from "../data/content";

export default function Gallery() {
  const [cat, setCat] = useState("");
  const [open, setOpen] = useState(null);
  const { data = [], isLoading } = useQuery({ queryKey: ["gallery", cat], queryFn: () => api.get("/gallery", { params: cat ? { category: cat } : {} }).then((r) => r.data) });
  return (
    <>
      <PageHero eyebrow="Gallery" title="Gallery" subtitle="Moments from federation programmes, meetings, conferences, campaigns and welfare activities." image="/images/houseboat.jpg" testId="gallery-hero" />
      <section className="py-16 md:py-20">
        <div className="container-x">
          <div className="flex flex-wrap gap-2">
            {["", ...GALLERY_CATEGORIES].map((c) => (
              <button key={c || "all"} onClick={() => setCat(c)} className={`rounded-full border px-4 py-1.5 text-xs font-semibold transition-colors ${cat === c ? "border-leaf bg-leaf text-white" : "border-slate-200 bg-white text-slate-600 hover:border-leaf"}`} data-testid={`gallery-filter-${c ? c.toLowerCase().replace(/\W+/g, "-") : "all"}`}>{c || "All"}</button>
            ))}
          </div>
          {!isLoading && !data.length && (
            <div className="mt-10 rounded-2xl border border-dashed border-slate-300 bg-white p-14 text-center" data-testid="gallery-empty">
              <Images className="mx-auto h-12 w-12 text-slate-300" />
              <p className="mt-4 font-display text-lg font-bold text-navy">Photos coming soon</p>
              <p className="mt-1 text-sm text-slate-500">Photographs from federation programmes will be published here.</p>
            </div>
          )}
          <div className="mt-10 columns-1 gap-5 sm:columns-2 lg:columns-3">
            {data.map((g, i) => (
              <Reveal key={g.id} delay={(i % 6) * 0.05} className="mb-5 break-inside-avoid">
                <button onClick={() => setOpen(g)} className="group relative block w-full overflow-hidden rounded-xl" data-testid={`gallery-item-${i}`}>
                  <img src={fileUrl(g.image_file_id)} alt={g.title} loading="lazy" className="w-full transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy/90 to-transparent p-4 text-left opacity-0 transition-opacity group-hover:opacity-100">
                    <p className="text-sm font-semibold text-white">{g.title}</p><p className="text-xs text-emerald-300">{g.category}</p>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-4xl p-2" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          {open && <><img src={fileUrl(open.image_file_id)} alt={open.title} className="max-h-[75vh] w-full rounded-lg object-contain" /><p className="px-3 py-2 text-sm font-semibold text-navy">{open.title} <span className="font-normal text-slate-500">· {open.category}</span></p></>}
        </DialogContent>
      </Dialog>
    </>
  );
}
